const sh = require('shelljs')

const stack = yargs => {
    console.log("ops stack --")
    // stack should be set when the application boots,
    // and then reset whenever this function is called.
    // It might be wise to separate the ui hooks from the
    // business code, since there are many cases where we'll
    // want to read the stack from other commands
}

module.exports = stack



// WEBPACK FOOTER //
// ./src/commands/stack.js